import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { useTheme } from '@mui/material'

import { SettingsDropdown, ExposePrivateKeyModal, SettingsDropdownMobile } from 'src/components'
import { ETranslationNs, PrivateKeyRequestFn, PrivateKeyVerifyFn } from 'src/types'
import { KeyIcon } from 'src/assets/icons'

interface IProps {
  verifyFn: PrivateKeyVerifyFn
  requestFn: PrivateKeyRequestFn
  mobile?: boolean
  disabled?: boolean
}

const ExposePrivateKeyButton = ({ requestFn, verifyFn, mobile, disabled = false }: IProps) => {
  const [t] = useTranslation(ETranslationNs.UserProfile)
  const [searchParams] = useSearchParams()
  const pkVerificationOpen = searchParams.get('pk_verification_open')
  const [open, setOpen] = useState(pkVerificationOpen === 'true')

  const theme = useTheme()

  const handleClose = () => setOpen(false)
  const handleExpose = () => setOpen(true)

  return (
    <>
      {mobile ? (
        <SettingsDropdownMobile
          handleClick={handleExpose}
          icon={KeyIcon}
          label={t('user-profile-expose-pk-button.v')}
        />
      ) : (
        <SettingsDropdown
          onButtonClick={handleExpose}
          text={t('user-profile-expose-pk-button.v')}
          icon={
            <KeyIcon
              color={disabled ? theme.palette.custom.grey2 : theme.palette.custom.darkBlue2}
            />
          }
          disabled={disabled}
        />
      )}
      <ExposePrivateKeyModal
        open={open}
        handleClose={handleClose}
        requestFn={requestFn}
        verifyFn={verifyFn}
      />
    </>
  )
}

export { ExposePrivateKeyButton }
